import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { api_url } from "../config/config";
import axios from "axios";
import HeroBannner from "./HeroBannner";

/* ── Icon helpers (inline SVG — no external img deps) ── */
const IconPin = ({ size = 16, color = "#5fbdb3" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const IconPhone = ({ size = 16, color = "#5fbdb3" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.72 12 19.79 19.79 0 0 1 1.65 3.4 2 2 0 0 1 3.62 1.21h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6.29 6.29l.97-.97a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);
const IconMap = ({ size = 16, color = "#5fbdb3" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
    <line x1="9" y1="3" x2="9" y2="18" />
    <line x1="15" y1="6" x2="15" y2="21" />
  </svg>
);
const IconSearch = ({ size = 16, color = "#5a7a77" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
const IconLocate = ({ size = 16, color = "#ff601e" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
    <circle cx="12" cy="12" r="8" strokeDasharray="2 3" />
  </svg>
);
const IconClock = ({ size = 14, color = "#5a7a77" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);
const IconStore = ({ size = 22, color = "#5fbdb3" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const StoreHeroIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#5fbdb3"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

/* ── Card theme cycling ── */
const THEMES = [
  {
    border: "border-[#c8d8d7] hover:border-[#5fbdb3]",
    accent: "from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]",
    badge: "bg-[#ddf0ee] text-[#1e4a46] border-[#aac9c7]",
    num: "text-[#5fbdb3]",
    shadow:
      "shadow-[0_2px_12px_rgba(95,189,179,0.09)] hover:shadow-[0_12px_32px_rgba(95,189,179,0.18)]",
  },
  {
    border: "border-[#ffd5c2] hover:border-[#ff601e]",
    accent: "from-[#ff601e] to-[#e55519]",
    badge: "bg-[#fff3ee] text-[#ff601e] border-[#ffd5c2]",
    num: "text-[#ff601e]",
    shadow:
      "shadow-[0_2px_12px_rgba(255,96,30,0.09)] hover:shadow-[0_12px_32px_rgba(255,96,30,0.18)]",
  },
];

/* ════════════════════════════════════════════════════════════ */
const BranchLocations = () => {
  const [pincode, setPincode] = useState("");
  const [branchData, setBranchData] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [error, setError] = useState("");
  const [detecting, setDetecting] = useState(false);
  const [fetching, setFetching] = useState(true);
  const inputRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* ── Fetch branches ── */
  const fetchBranches = async () => {
    setFetching(true);
    try {
      const res = await axios.get(`${api_url}/branches`);
      const raw = res.data.results || [];
      const uniq = [...new Map(raw.map((b) => [b.branch_id, b])).values()];
      setBranchData(uniq);
      setFiltered(uniq);
    } catch {
      setError("Failed to load store locations. Please try again.");
    } finally {
      setFetching(false);
    }
  };
  useEffect(() => {
    fetchBranches();
  }, []);

  /* ── Display list ── */
  const displayList = pincode.length === 6 ? filtered : branchData;

  /* ── Pincode input ── */
  const handlePincodeChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 6);
    setPincode(val);
    setError("");
    if (val.length === 0) {
      setFiltered(branchData);
      return;
    }
    if (val.length < 6) {
      setError("Enter all 6 digits of your pincode");
      setFiltered([]);
      return;
    }
    const f = branchData.filter((b) => String(b.pincode) === val);
    setFiltered(f);
    if (!f.length) setError("No stores found near this pincode.");
  };

  const clearSearch = () => {
    setPincode("");
    setFiltered(branchData);
    setError("");
    inputRef.current?.focus();
  };

  /* ── Detect location ── */
  const detectMyLocation = () => {
    setDetecting(true);
    setError("");
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser.");
      setDetecting(false);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async ({ coords: { latitude, longitude } }) => {
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
          );
          const data = await res.json();
          const pin = data.address?.postcode;
          if (pin) {
            setPincode(pin);
            const f = branchData.filter(
              (b) => String(b.pincode) === String(pin),
            );
            setFiltered(f);
            if (!f.length) setError("No stores found near your location.");
          } else {
            setError("Could not determine pincode from your location.");
          }
        } catch {
          setError("Failed to fetch location details.");
        } finally {
          setDetecting(false);
        }
      },
      () => {
        setError(
          "Location access denied. Please enable location in browser settings.",
        );
        setDetecting(false);
      },
    );
  };

  /* ═══════════════════════════════════════════════════ */
  return (
    <div className="min-h-screen bg-[#f2f8f7] font-poppins">
      <Helmet>
        <title>Store Locations | Online Medical Store</title>
        <meta
          name="description"
          content="Find a store near you — browse all locations, addresses, contact numbers and directions."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* ── Hero banner ── */}
      <HeroBannner
        breadcrumbs={[
          { label: "Home", to: "/home" },
          { label: "Store Locations" },
        ]}
        title="Store Locations"
        subtitle={
          fetching
            ? "Loading stores…"
            : `${branchData.length} store${branchData.length !== 1 ? "s" : ""} near you`
        }
        badge="Locate"
        icon={<StoreHeroIcon />}
        accentColor="#5fbdb3"
      />

      {/* ── Search + Detect bar ── */}
      <div className="bg-white border-b border-[#c8d8d7] px-4 sm:px-6 lg:px-8 py-4">
        <div className="w-full mx-auto flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
          {/* Pincode input */}
          <div className="relative flex-1 max-w-full sm:max-w-[280px]">
            <div className="absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none">
              <IconSearch size={15} />
            </div>
            <input
              ref={inputRef}
              type="text"
              inputMode="numeric"
              placeholder="Search by pincode…"
              value={pincode}
              onChange={handlePincodeChange}
              maxLength={6}
              className="w-full h-11 pl-9 pr-10 rounded-xl border-[1.5px] border-[#c8d8d7] bg-[#f2f8f7] focus:border-[#5fbdb3] focus:bg-white outline-none text-[13px] font-medium text-[#1e3330] placeholder-[#5a7a77] transition-all duration-200"
            />
            {pincode && (
              <button
                onClick={clearSearch}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-[#aac9c7] flex items-center justify-center hover:bg-[#5fbdb3] transition-colors cursor-pointer"
              >
                <svg
                  width="9"
                  height="9"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            )}
          </div>

          {/* Detect my location */}
          <button
            onClick={detectMyLocation}
            disabled={detecting || fetching}
            className="flex items-center justify-center gap-2.5 h-11 px-5 rounded-xl border-[1.5px] border-[#ffd5c2] bg-[#fff3ee] text-[#ff601e] text-[13px] font-bold hover:bg-[#ff601e] hover:text-white hover:border-[#ff601e] disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer flex-shrink-0"
          >
            <span className={detecting ? "animate-spin" : ""}>
              <IconLocate size={16} color="currentColor" />
            </span>
            {detecting ? "Detecting…" : "Detect My Location"}
          </button>

          {/* Count pill */}
          {!fetching && (
            <div className="hidden sm:flex items-center gap-1.5 bg-[#ddf0ee] border border-[#aac9c7] rounded-xl px-3.5 h-11 flex-shrink-0">
              <span className="text-[13px] font-black text-[#1e4a46]">
                {displayList.length}
              </span>
              <span className="text-[12px] text-[#5fbdb3] font-medium">
                stores
              </span>
            </div>
          )}
        </div>

        {/* Error message */}
        {error && (
          <div className="mx-auto mt-3 flex items-center gap-2 bg-[#fff3ee] border border-[#ffd5c2] rounded-xl px-4 py-2.5">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ff601e"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            <p className="text-[12px] font-medium text-[#c44a14]">{error}</p>
          </div>
        )}
      </div>

      {/* ── Content area ── */}
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Loading skeletons */}
        {fetching ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="bg-white rounded-2xl border border-[#c8d8d7] overflow-hidden animate-pulse"
              >
                <div className="h-[3px] bg-[#dde9e8]" />
                <div className="p-5 flex flex-col gap-3">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-xl bg-[#dde9e8]" />
                    <div className="flex-1">
                      <div className="h-3 bg-[#dde9e8] rounded-full w-3/4 mb-2" />
                      <div className="h-2.5 bg-[#dde9e8] rounded-full w-1/3" />
                    </div>
                  </div>
                  <div className="h-2.5 bg-[#dde9e8] rounded-full w-full" />
                  <div className="h-2.5 bg-[#dde9e8] rounded-full w-4/5" />
                  <div className="flex gap-2 pt-2">
                    <div className="h-9 bg-[#dde9e8] rounded-xl flex-1" />
                    <div className="h-9 bg-[#dde9e8] rounded-xl flex-1" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : displayList.length === 0 ? (
          /* Empty state */
          <div className="flex flex-col items-center justify-center py-20 gap-4">
            <div className="w-16 h-16 rounded-2xl bg-[#ddf0ee] border border-[#aac9c7] flex items-center justify-center">
              <IconStore size={28} />
            </div>
            <div className="text-center">
              <p className="font-bold text-[16px] text-[#1e3330] mb-1">
                No stores found
              </p>
              <p className="text-[13px] text-[#5a7a77]">
                Try a different pincode or{" "}
                <button
                  onClick={clearSearch}
                  className="text-[#5fbdb3] font-semibold hover:text-[#1e4a46] cursor-pointer bg-transparent border-none"
                >
                  view all stores
                </button>
              </p>
            </div>
          </div>
        ) : (
          <>
            {/* Results label */}
            {pincode.length === 6 && (
              <div className="flex items-center gap-2 mb-5">
                <span className="text-[12px] font-bold text-[#1e4a46] bg-[#ddf0ee] border border-[#aac9c7] rounded-full px-3 py-1">
                  {displayList.length} store
                  {displayList.length !== 1 ? "s" : ""} near {pincode}
                </span>
                <button
                  onClick={clearSearch}
                  className="text-[11px] font-semibold text-[#5a7a77] hover:text-[#ff601e] transition-colors cursor-pointer bg-transparent border-none"
                >
                  Clear filter
                </button>
              </div>
            )}

            {/* ── Store cards grid ── */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {displayList.map((branch, index) => {
                const t = THEMES[index % THEMES.length];
                return (
                  <div
                    key={branch.branch_id || index}
                    className={`group bg-white rounded-2xl border-[1.5px] ${t.border} overflow-hidden ${t.shadow} transition-all duration-300 hover:-translate-y-1 flex flex-col`}
                    style={{
                      animation: `fadeInUp 0.35s ease ${(index % 4) * 60}ms both`,
                    }}
                  >
                    {/* Accent top bar */}
                    <div
                      className={`h-[3px] w-full bg-gradient-to-r ${t.accent} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}
                    />

                    <div className="p-5 flex flex-col gap-4 flex-1">
                      {/* Store header */}
                      <div className="flex items-start gap-3.5">
                        {/* Number badge */}
                        <div
                          className={`w-12 h-12 rounded-xl border flex items-center justify-center flex-shrink-0 font-black text-[18px] ${t.badge}`}
                          style={{ fontFamily: "'Nunito',sans-serif" }}
                        >
                          {String(index + 1).padStart(2, "0")}
                        </div>
                        <div className="flex-1 min-w-0">
                          <h3 className="text-[14px] font-black text-[#1e3330] leading-snug line-clamp-2 group-hover:text-[#1e4a46] transition-colors">
                            {branch.area || "Store Location"}
                          </h3>
                          <div className="flex items-center gap-1.5 mt-1">
                            <span className="text-[11px] font-bold text-[#5a7a77] bg-[#f2f8f7] border border-[#c8d8d7] rounded-full px-2.5 py-0.5">
                              PIN: {branch.pincode}
                            </span>
                            {/* <span className="flex items-center gap-1 text-[10.5px] font-semibold text-[#5a7a77]">
                              <IconClock size={11}/> Open Today
                            </span> */}
                          </div>
                        </div>
                      </div>

                      {/* Divider */}
                      <div className="h-px bg-[#e8f5f4]" />

                      {/* Address */}
                      <div className="flex items-start gap-2.5">
                        <div className="w-7 h-7 rounded-[8px] bg-[#f2f8f7] border border-[#c8d8d7] flex items-center justify-center flex-shrink-0 mt-0.5">
                          <IconPin size={14} />
                        </div>
                        <p className="text-[12.5px] text-[#2d5250] leading-relaxed flex-1">
                          {branch.branch_address || "Address not available"}
                        </p>
                      </div>

                      {/* Contact */}
                      {branch.contact_number && (
                        <div className="flex items-center gap-2.5">
                          <div className="w-7 h-7 rounded-[8px] bg-[#f2f8f7] border border-[#c8d8d7] flex items-center justify-center flex-shrink-0">
                            <IconPhone size={14} />
                          </div>
                          <a
                            href={`tel:${branch.contact_number}`}
                            className="text-[12.5px] font-semibold text-[#1e4a46] hover:text-[#ff601e] transition-colors"
                            style={{ textDecoration: "none" }}
                          >
                            {branch.contact_number}
                          </a>
                        </div>
                      )}

                      {/* Spacer */}
                      <div className="flex-1" />

                      {/* Action buttons */}
                      <div className="flex gap-2.5 pt-1">
                        <a
                          href={`tel:${branch.contact_number}`}
                          style={{ textDecoration: "none", flex: 1 }}
                        >
                          <button className="w-full h-10 rounded-xl border-[1.5px] border-[#aac9c7] bg-[#f2f8f7] text-[#1e4a46] text-[12px] font-bold flex items-center justify-center gap-1.5 hover:bg-[#ddf0ee] hover:border-[#5fbdb3] transition-all duration-200 cursor-pointer">
                            <IconPhone size={14} color="#1e4a46" />
                            Call Store
                          </button>
                        </a>
                        <a
  href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(branch.location)}`}
  target="_blank"
  rel="noopener noreferrer"
  style={{ textDecoration: "none", flex: 1 }}
>
  <button className="w-full h-10 rounded-xl bg-[#1e4a46] text-white text-[12px] font-bold flex items-center justify-center gap-1.5 hover:bg-[#ff601e] transition-all duration-200 border-none cursor-pointer">
    <IconMap size={14} color="white" />
    Get Directions
  </button>
</a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>

      <style>{`
        @keyframes fadeInUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
        @keyframes spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }
        .animate-spin svg { animation: spin 1s linear infinite; }
        .animate-pulse { animation: pulse 2s cubic-bezier(.4,0,.6,1) infinite; }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.5} }
      `}</style>
    </div>
  );
};

export default BranchLocations;
